import { render } from "./tender_general.vue?vue&type=template&id=2a108b38"
import script from "./tender_general.vue?vue&type=script&lang=js"
export * from "./tender_general.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_general.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a108b38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a108b38', __exports__)) {
    console.log('reload')
    api.reload('2a108b38', __exports__)
  }
  
  module.hot.accept("./tender_general.vue?vue&type=template&id=2a108b38", () => {
    console.log('re-render')
    api.rerender('2a108b38', render)
  })

}


export default __exports__